'use client';
import './savedAreas.scss';

/* Components  */
import customToaster from '@/components/toast/CustomToaster';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';

import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import {
  Box,
  Button,
  CircularProgress,
  Fade,
  FormControl,
  IconButton,
  Link,
  List,
  ListItem,
  Menu,
  MenuItem,
  Stack,
  styled,
  TextField,
  Typography,
} from '@mui/material';

/* React library */
import React, { useState, useEffect, useRef, useContext, useTransition } from 'react';

/* Third Party Library */
import { Scrollbar } from 'react-scrollbars-custom';
import { Controller, useForm } from 'react-hook-form';
/* Server functions */

/* Map Library */
import Polygon from '@arcgis/core/geometry/Polygon';
import Graphic from '@arcgis/core/Graphic';
import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils';
import { MixpanelTracking } from '@/services/mixpanel';
import { MixpanelEvent, MixpanelEventHub } from '@/services/eventEnums';
import { getAreaLabel, getIntersectionAreaLabel } from '@/helper/getArea';
import { useSpinnerContext } from '@/context/SpinnerContext';
import { triggerEvent } from '@/lib/events';
import { useTranslation } from 'react-i18next';
import { useShoppingCart } from '@/context/ShoppingCartContext';
import { MapContext, SketchViewModelType } from '@/context/MapContext/MapProvider';
import { getCircleGraphicsAndSquarePolygonFromCenter } from '../utils/utils';

import { isPlatformExplore, isPlatformHub } from '@/constants';
import { usePathname } from 'next/navigation';
import SaveAreaPopover from './saveAreaPopover';
import MonitorAoiPopover from './monitorAoiPopover';

import CreateOrEditMonitorAoi from './PopoverContent/CreateMonitorAoi';

import ListMonitorAoi from './PopoverContent/ListMonitorAoi';

import { setDefaultProjectName } from '@/lib/utils';
import { IProjectListData } from '@/components/organization/userManagement/modal/interfaces';
import { MonitorAoiHelper } from './savedAreas.types';
import { ScrollState } from 'react-scrollbars-custom/dist/types/types';
import { getAllMonitorAoi_rh } from '@/network/Hub/routeHandlerService/projectsCollection';
import { getProjects_rh } from '@/network/Hub/routeHandlerService/projects';
import {
  deleteSavedArea_rh,
  getAreaLocationCoordinates_rh,
  getAreaLocations_rh,
  renameSavedArea_rh,
} from '@/network/routeHandlerService/savedAreas';

export type MonitorAoiElMenu = {
  element: HTMLButtonElement | null;
  state: number;
  monitorAoiData: any;
};

export default function SavedAreas({
  userData,
  sketchVM,
  view,
  previewLayer,
  intersectLayer,
  orderNewTab,
  areaRef,
  saveBtnDisable,

  handleSaveArea,
  monitorAoiBtnDisable,
  locationArea,
  setLocationArea,
}: {
  userData: any;
  sketchVM: SketchViewModelType;
  view: any;
  previewLayer: any;
  intersectLayer: any;
  orderNewTab: any;
  areaRef: any;
  saveBtnDisable: boolean;
  monitorAoiBtnDisable: boolean;
  handleSaveArea: Function;
  setLocationArea: React.Dispatch<
    React.SetStateAction<{
      items: any[];
      next: string | null;
    }>
  >;
  locationArea: {
    items: any[];
    next: string | null;
  };
}) {
  //spinner context
  const { startLoaderEvent, stopLoaderEvent } = useSpinnerContext();

  // Monitor AOI popover states
  const [monitorAoiAnchorEl, setMonitorAoiAnchorEl] = useState<SVGSVGElement | null>(null);
  const pathname = usePathname();
  const [loading, setLoading] = useState<boolean>(true);

  const [isModalClicked, setIsModalClicked] = useState(false);
  const [saveAreaPageLoading, setSaveAreaPageLoading] = useState<boolean>(false);
  const [isMonitorAoiLoading, startFetchingMonitorAoi] = useTransition();
  const [monitorAoiList, setMonitorAoiList] = useState<any[]>([]);
  const monitorAoiPopoverButtonRef = useRef<SVGSVGElement | null>(null);
  const [selectedMonitorAoi, setSelectedMonitorAoi] = useState<any>(null);
  const [isProjectLoading, startFetchingProject] = useTransition();
  const [projectList, setProjectList] = useState<IProjectListData[]>([]);
  const monitorAoiHelperRef = useRef<MonitorAoiHelper>({
    formHandleSubmitCb: null,
    formGetValueCb: null,
  });

  //row menu states
  const [anchorElMenu, setAnchorElMenu] = useState<{
    element: HTMLButtonElement | null;
    state: number;
  }>({ element: null, state: 0 });

  //rename popover states
  const [editField, setEditField] = useState<boolean>(false);

  const { t } = useTranslation('orderImagery');
  const saveAreaRef = useRef<{ name: string; id: string }>({ name: '', id: '' });
  const renameInputRef = useRef<string>('');
  const {
    orderNewDataType,
    orderNewIsGuaranteedCapture,
    tabValue,
    setOpenCreateAccountDrawer,
    setDrawer,
  } = useShoppingCart();
  const textFieldRef = useRef<any>();

  //saved areaspopover content refs
  const popoverContentRef = useRef<number>(1);
  const popoverButtonRef = useRef<HTMLButtonElement | null>(null);

  //add save area popover states and refs
  const {
    control,
    handleSubmit,
    getValues,
    reset,

    formState: { errors },
  } = useForm();

  const { sarSelectedRef, hideSaveMonitorAreaButtons } = useContext(MapContext);

  const monitorAoiOpen = Boolean(monitorAoiAnchorEl);
  const menuOpen = Boolean(anchorElMenu.element);

  const monitorAoiId = monitorAoiOpen ? 'simple-popover-monitor-aoi' : undefined;
  const [isMonitorAoiActive, setIsMonitorAoiActive] = useState(false);
  const [menuLoader, setMenuLoader] = useState({ id: '', state: false });
  const selectedSavedAreaCoordinatesRef = useRef<any>();
  const pendingScrollFetchRef = useRef<Promise<void> | null>(null);

  //saved area popover states
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isActive, setIsActive] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const onScrollHandler: any = (scrollValue: ScrollState, previousScrollValue: ScrollState) => {
    const { scrollTop, clientHeight, contentScrollHeight } = scrollValue;

    const scrollPerc = Math.floor(((scrollTop + clientHeight) / contentScrollHeight) * 100);

    if (scrollPerc > 90 && locationArea.next && !pendingScrollFetchRef.current) {
      pendingScrollFetchRef.current = (async () => {
        setSaveAreaPageLoading(true);
        try {
          const result = await getAreaLocations_rh(locationArea.next);

          if (result?.error) {
            customToaster(`${t('errorGettingLocations')}: ${result.error}`);
            return;
          }

          const newData = [...locationArea.items, ...(result?.data || [])];
          // getting duplicates so removing it
          // the map set id => data
          // which removes duplicates
          const unique = new Map(newData.map(item => [item.id, item])).values();

          if (result?.data) {
            setLocationArea({
              items: Array.from(unique),
              next: result.next,
            });
          }
        } finally {
          setSaveAreaPageLoading(false);
          pendingScrollFetchRef.current = null;
        }
      })();
    }
  };

  const getPopOverContent = (user: any) => {
    if (!user)
      return (
        <Box className="popover-content">
          <Typography variant="subtitle1">{t('noAccount1')}</Typography>
          <Button
            name="no-account-button"
            fullWidth
            variant="contained"
            onClick={() => {
              MixpanelTracking.getInstance().track(MixpanelEvent.ACCOUNT_SIGN_UP_CLICK);
              const socialSignOnUrl = `/auth/login?returnTo=${pathname}?isSignUp=true`;
              window.location.href = socialSignOnUrl;
            }}
          >
            {t('noAccount2')}
          </Button>
          <Typography variant="body1">
            {t('noAccount3')}{' '}
            <Link
              component="button"
              onClick={() => {
                MixpanelTracking.getInstance().track(MixpanelEvent.ACCOUNT_SIGNIN_CLICK);
                const emailPasswordSignOnUrl = `/auth/login?returnTo=${pathname}`;
                // testing social signin feature with posthog
                if (isPlatformExplore) {
                  const socialSignInUrl = `/auth/login?returnTo=${pathname}`;
                  window.location.href = socialSignInUrl;
                } else {
                  window.location.href = emailPasswordSignOnUrl;
                }
              }}
            >
              {t('signIn')}{' '}
            </Link>
          </Typography>
        </Box>
      );

    switch (popoverContentRef.current) {
      // showing the listing
      case 1:
        return (
          <Box className="popover-content">
            <Stack direction="row" spacing={2} className="popover-btns">
              <Button
                name="draw-rectangle-polygon-button"
                variant="outlined"
                color="secondary"
                startIcon={<i className="icon-rectangle-polygon"></i>}
                size="small"
                onClick={event => {
                  event.stopPropagation();

                  handleClose();
                  //removing previous graphics if exist
                  sketchVM.layer.removeAll();
                  previewLayer.source.elements.removeAll();
                  intersectLayer.removeAll();

                  //for clearing the file polygon when clicking on draw rectangle polygon
                  MixpanelTracking.getInstance().clearProperty('file');
                  //for tracking
                  MixpanelTracking.getInstance().track(
                    MixpanelEventHub.HUB_MY_SAVED_AREAS_DRAW_NEW_AREA
                  );

                  //getting the ref of area label
                  let childNode = areaRef.current?.children[1];
                  if (!childNode) return;
                  //resetting the area value
                  childNode.children[0].textContent = orderNewTab
                    ? getIntersectionAreaLabel(
                        0,
                        t,
                        orderNewDataType,
                        tabValue,
                        orderNewIsGuaranteedCapture
                      )
                    : getAreaLabel(0, t);
                  //clearing the intersection area value
                  sketchVM.emit('update', { state: 'clearIntersectArea' });
                  sketchVM.create('rectangle');
                }}
              >
                {t('drawNewArea')}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                startIcon={<UploadFileOutlinedIcon name="upload-file-button" />}
                component="label"
              >
                {t('uploadAFile')}
                <VisuallyHiddenInput
                  onChange={async (e: any) => {
                    if (!e.target.files) return;
                    handleClose();

                    e.target.files.length != 0 &&
                      (await sketchVM.emit('update', {
                        state: 'fileUpload',
                        file: e.target.files[0],
                      }));
                  }}
                  type="file"
                />
              </Button>
            </Stack>
            <List className="saved-areas-data">
              <Scrollbar className="scroll-thumb-color" onScroll={onScrollHandler}>
                {loading ? (
                  <Box className="text-center">
                    <Typography variant="body1" className="mb-2">
                      {t('gettingSavedAreas')}
                    </Typography>
                    <CircularProgress thickness={6.5} />
                  </Box>
                ) : locationArea.items.length > 0 ? (
                  locationArea.items.map(value => (
                    <ListItem
                      sx={{ cursor: 'pointer' }}
                      key={value.id}
                      onClick={async () => {
                        // set the loader
                        setMenuLoader({ id: value?.id, state: true });
                        //get the coordinates by id
                        const coordinates = await getAreaLocationCoordinates_rh(value.id);
                        if (coordinates?.error) {
                          customToaster(
                            `${t('locationDetailsError', 'Failed to fetch location details')}: ${coordinates.error}`
                          );
                          setMenuLoader({ id: value?.id, state: false });
                          return;
                        }

                        setMenuLoader({ id: value?.id, state: false });
                        //close the box
                        handleClose();
                        //draw a polygon
                        const polygon = new Polygon({
                          rings: coordinates,
                          spatialReference: { wkid: 4326 },
                        });

                        let squarePolygon: any = null;
                        let circleGraphics: any = null;
                        let centerPointGraphics: any = null;
                        //if sar flow is active
                        if (sarSelectedRef.current === true) {
                          customToaster(t('sarInfoToast'), 'success');
                          //object is location: {x: num,y:num}
                          const location = { x: polygon.centroid.x, y: polygon.centroid.y };
                          let result = getCircleGraphicsAndSquarePolygonFromCenter(location);
                          squarePolygon = result.squarePolygon;
                          circleGraphics = result.circleGraphics;
                          centerPointGraphics = result.centerPointGraphic;
                          // bbox = squarePolygon.rings;
                        }

                        // creating a graphic and showing it to a map
                        const graphic = new Graphic({
                          geometry: webMercatorUtils.geographicToWebMercator(polygon),
                          symbol: sketchVM?.polygonSymbol.clone(),
                          visible: !sarSelectedRef.current,
                        });
                        graphic.setAttribute('disable', true);
                        graphic.setAttribute('savedArea', true);

                        //remove previous grpahics
                        previewLayer.source.elements.removeAll();
                        sketchVM.layer.removeAll();

                        //add the new polygon graphic
                        sketchVM.layer.add(graphic);
                        //if the sar flow is active add the circle graphics
                        sarSelectedRef.current && sketchVM.layer.add(circleGraphics),
                          sketchVM.layer.add(centerPointGraphics);

                        //firing the update event to set area in MapBox
                        sarSelectedRef.current
                          ? sketchVM.update([circleGraphics, centerPointGraphics], { tool: 'move' })
                          : sketchVM.update(graphic);

                        //firing the update event to initiate search
                        !sarSelectedRef.current &&
                          sketchVM.emit('update', {
                            state: 'active',
                            graphics: [graphic],
                            toolEventInfo: { type: 'move-stop' },
                          });

                        //emit the update event
                        // sketchVM.emit('update', {
                        //   state: 'showSaveArea',
                        //   graphic,
                        // });

                        await view.goTo({ target: polygon.extent }, { duration: 4000 });

                        MixpanelTracking.getInstance().track(
                          MixpanelEventHub.HUB_MY_SAVED_AREAS_LOAD_SAVED_AOI,
                          {
                            coordinates,
                            saved_area_id: value.id,
                            name: value.name,
                          }
                        );
                      }}
                    >
                      <Typography
                        noWrap
                        title={value.name}
                        maxWidth={'180px'}
                        display={'block'}
                        variant="subtitle2"
                      >
                        {value.name}
                      </Typography>

                      <Stack direction="row" alignItems="center" className="actions" spacing={2}>
                        <Typography variant="body2">{value.aoiSize}</Typography>
                        <IconButton
                          onClick={async event => {
                            MixpanelTracking.getInstance().track(
                              MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_ACTION
                            );

                            setMenuLoader({ id: value?.id, state: true });
                            await handleMenuClick(event, value.name, value.id);
                          }}
                          size="small"
                        >
                          {/* <MoreHorizOutlinedIcon /> */}
                          {menuLoader?.id === value?.id && menuLoader?.state ? (
                            <CircularProgress
                              sx={{ height: '14px !important', width: '14px !important' }}
                            />
                          ) : (
                            <MoreHorizOutlinedIcon />
                          )}
                        </IconButton>
                        <Menu
                          onClose={handleMenuClose}
                          open={menuOpen}
                          anchorEl={anchorElMenu.element}
                        >
                          {menuLoader?.id === value?.id && menuLoader?.state ? (
                            <Fade in={menuLoader?.state} unmountOnExit>
                              <CircularProgress
                                sx={{ height: '14px !important', width: '14px !important' }}
                              />
                            </Fade>
                          ) : (
                            <Box key={value?.id}>
                              <MenuItem
                                onClick={(event: any) => {
                                  event.stopPropagation();
                                  event.preventDefault();
                                  if (!selectedSavedAreaCoordinatesRef) {
                                    setAnchorElMenu({ element: null, state: 0 });

                                    return customToaster(
                                      `${t('noCoordinates', 'No coordinates found')}`
                                    );
                                  }
                                  downloadAOIJsonFile(value?.name);
                                  MixpanelTracking.getInstance().track(
                                    MixpanelEvent.DOWNLOAD_SAVED_AREA_AOI,
                                    {
                                      saved_area_id: value?.id,
                                    }
                                  );
                                  selectedSavedAreaCoordinatesRef.current = null;
                                  setAnchorElMenu({ element: null, state: 0 });
                                }}
                              >
                                {t('downloadAOI')}
                              </MenuItem>
                              <MenuItem
                                onClick={(event: React.MouseEvent) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  MixpanelTracking.getInstance().track(
                                    MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_ACTION_RENAME
                                  );
                                  popoverContentRef.current = 2;
                                  setAnchorElMenu({ element: null, state: 1 });
                                }}
                              >
                                {t('rename')}
                              </MenuItem>

                              <MenuItem
                                onClick={async (event: React.MouseEvent) => {
                                  event.preventDefault();
                                  event.stopPropagation();

                                  triggerEvent(startLoaderEvent);
                                  try {
                                    setAnchorElMenu({ element: null, state: 0 });

                                    const result = await deleteSavedArea_rh(saveAreaRef.current.id);

                                    if (result?.message) {
                                      customToaster(`${result?.message}`, 'success');
                                    }
                                    if (result?.error) {
                                      customToaster(`${result?.error}`);
                                      throw new Error(`${result?.error}`);
                                    }

                                    setLocationArea({
                                      items: locationArea.items.filter(
                                        value => value.id !== saveAreaRef.current.id
                                      ),
                                      next: locationArea.next,
                                    });
                                  } catch (error) {
                                    var errorMsg = error;
                                  } finally {
                                    triggerEvent(stopLoaderEvent);
                                    MixpanelTracking.getInstance().track(
                                      MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_DELETE,
                                      {
                                        success: errorMsg ? `No, ${errorMsg}` : `yes`,
                                      }
                                    );
                                  }
                                }}
                              >
                                {t('delete')}
                              </MenuItem>
                            </Box>
                          )}
                        </Menu>
                      </Stack>
                    </ListItem>
                  ))
                ) : (
                  <Typography variant="body2" className="text-center">
                    {t('noSavedAreas')}
                  </Typography>
                )}

                {locationArea.next && (
                  <ListItem
                    sx={{
                      justifyContent: 'center !important',
                      background: 'none !important',
                      marginTop: '0px !important',
                    }}
                  >
                    {saveAreaPageLoading && (
                      <CircularProgress
                        sx={{ height: '25px !important', width: '25px !important' }}
                      />
                    )}
                  </ListItem>
                )}
              </Scrollbar>
            </List>
          </Box>
        );

      // Rename saved aoi component
      case 2:
        return (
          <Box className="popover-content">
            <Button
              href="#"
              variant="text"
              className="return-back-btn"
              color="secondary"
              startIcon={<ArrowBackOutlinedIcon name="return-back-button" />}
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();

                popoverContentRef.current = 1;
                setAnchorElMenu({ element: null, state: 0 });
                MixpanelTracking.getInstance().track(
                  MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_RENAME_CANCEL
                );
              }}
            >
              {t('returnToSavedAreas')}
            </Button>

            <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="space-between">
              <TextField
                id="filled-basic"
                defaultValue={saveAreaRef.current.name}
                onChange={event => {
                  renameInputRef.current = event.target.value;
                }}
                label={t('rename', 'Rename')}
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  setEditField(true);
                }}
                inputRef={textFieldRef}
                variant="filled"
              />
              <Stack direction="row" spacing={0.5}>
                {editField ? (
                  <>
                    <IconButton
                      onClick={async event => {
                        event.stopPropagation();
                        event.preventDefault();

                        triggerEvent(startLoaderEvent);

                        try {
                          //make api call here

                          const result = await renameSavedArea_rh(
                            saveAreaRef.current.id,
                            renameInputRef.current
                          );

                          if (result?.message || result?.error) {
                            triggerEvent(stopLoaderEvent);
                            result?.message && customToaster(`${result?.message}`);
                            result?.error && customToaster(`${result?.error}`);
                            throw new Error(
                              result?.message ? `${result?.message}` : `${result?.error}`
                            );
                          }
                          setLocationArea({
                            items: locationArea.items.map(value => {
                              if (value.id === saveAreaRef.current.id)
                                return { ...value, name: renameInputRef.current };

                              return value;
                            }),
                            next: locationArea.next,
                          });

                          setEditField(false);
                        } catch (error) {
                          var errorMessage = error;
                        } finally {
                          triggerEvent(stopLoaderEvent);
                          MixpanelTracking.getInstance().track(
                            MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_RENAME_SAVE,
                            {
                              success: errorMessage ? `No, ${errorMessage}` : `yes`,
                            }
                          );
                        }
                      }}
                      size="small"
                      color="secondary"
                      aria-label="delete"
                    >
                      <CheckOutlinedIcon />
                    </IconButton>
                    <IconButton
                      onClick={event => {
                        event.stopPropagation();
                        event.preventDefault();

                        textFieldRef.current.value = saveAreaRef.current.name;
                        setEditField(false);

                        MixpanelTracking.getInstance().track(
                          MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_RENAME_CANCEL
                        );
                      }}
                      size="small"
                      color="secondary"
                      aria-label="delete"
                    >
                      <CloseOutlinedIcon />
                    </IconButton>
                  </>
                ) : (
                  <IconButton
                    onClick={event => {
                      event.preventDefault();
                      event.stopPropagation();
                      textFieldRef.current.focus();
                      setEditField(true);
                    }}
                    size="small"
                    color="secondary"
                    aria-label="delete"
                  >
                    <EditOutlinedIcon />
                  </IconButton>
                )}
              </Stack>
            </Stack>
          </Box>
        );

      // Add saved aoi component
      case 3:
        return (
          <Box className="popover-content">
            <form onSubmit={handleSubmit(onSubmit, onError)}>
              <Controller
                control={control}
                rules={{ required: true }}
                name="Name"
                defaultValue=""
                render={({ field: { ref, ...field } }) => (
                  <FormControl variant="filled" fullWidth>
                    <TextField
                      label={t('name', 'Name')}
                      variant="filled"
                      {...field}
                      onChange={(e: any) => {
                        field.onChange(e.target.value);
                      }}
                      inputRef={ref}
                    />
                  </FormControl>
                )}
              />
              <Stack className="mt-3" direction="row" spacing={1} justifyContent="flex-end">
                <Button
                  variant="outlined"
                  name="cancel-button"
                  color="secondary"
                  onClick={() => {
                    reset();
                    handleClose();
                  }}
                >
                  {t('cancel')}
                </Button>
                <Button name="save-button" variant="contained" type="submit">
                  {t('save')}
                </Button>
              </Stack>
            </form>
          </Box>
        );

      // Listing monitor aoi component
      case 4:
        return (
          <ListMonitorAoi
            sketchVM={sketchVM}
            handleClose={handleClose}
            monitorAoiList={monitorAoiList}
            isMonitorAoiLoading={isMonitorAoiLoading}
            view={view}
            previewLayer={previewLayer}
            intersectLayer={intersectLayer}
            orderNewTab={orderNewTab}
            areaRef={areaRef}
            orderNewDataType={orderNewDataType}
            orderNewIsGuaranteedCapture={orderNewIsGuaranteedCapture}
            tabValue={tabValue}
            setSelectedMonitorAoi={setSelectedMonitorAoi}
            popoverContentRef={popoverContentRef}
            setIsMonitorAoiActive={setIsMonitorAoiActive}
            openMonitorAoiPopover={openMonitorAoiPopover}
          />
        );

      // Add monitor aoi component
      case 5:
        return (
          <CreateOrEditMonitorAoi
            sketchVM={sketchVM}
            handleClose={handleClose}
            type="create"
            popoverContentRef={popoverContentRef}
            setSelectedMonitorAoi={setSelectedMonitorAoi}
            projectList={projectList}
            isProjectLoading={isProjectLoading}
            monitorAoiList={monitorAoiList}
            setMonitorAoiList={setMonitorAoiList}
            monitorAoiHelperRef={monitorAoiHelperRef}
          />
        );

      // Edit monitor aoi component
      case 6:
        return (
          <CreateOrEditMonitorAoi
            monitorAoiData={selectedMonitorAoi}
            sketchVM={sketchVM}
            handleClose={handleClose}
            type="edit"
            popoverContentRef={popoverContentRef}
            setSelectedMonitorAoi={setSelectedMonitorAoi}
            projectList={projectList}
            isProjectLoading={isProjectLoading}
            monitorAoiList={monitorAoiList}
            setMonitorAoiList={setMonitorAoiList}
            monitorAoiHelperRef={monitorAoiHelperRef}
          />
        );
    }
  };

  useEffect(() => {
    //if user is not there or any  modal is not clicked return;
    if (!userData) return;
    if (!isModalClicked) return;
    async function getLocationArea() {
      setLoading(true);
      const result = await getAreaLocations_rh(null);

      if (result?.error) {
        customToaster(`${t('errorGettingLocations')}: ${result.error}`);
        return;
      }

      if (result?.data) {
        setLocationArea({ items: result.data, next: result.next });
      }
      setLoading(false);
    }

    async function getMonitorAoi() {
      // avoid extra call
      // also on frontend we are handling the list with states not with api
      if (monitorAoiList.length > 0) return;

      const response = await getAllMonitorAoi_rh();

      if (response?.data) {
        setMonitorAoiList(response?.data);
      } else if (response?.error) {
        customToaster(`${t('errorGettingMonitorAoi')}: ${response.error}`);
        return;
      }
    }
    const getAllProjectsData = async (): Promise<void> => {
      // avoid extra call
      // also on frontend we are handling the list with states not with api
      if (projectList.length > 0) return;
      try {
        // eslint-disable-next-line require-use-server
        const projects = await getProjects_rh(false);

        if (projects?.data) {
          const projectDataWithDefaultName = setDefaultProjectName(projects?.data);

          setProjectList(projectDataWithDefaultName);
        } else {
          customToaster(projects?.error || t('common:generalError'));
        }
      } catch (error) {
        customToaster(t('common:generalError'));
      }
    };

    startFetchingProject(getAllProjectsData);

    startFetchingMonitorAoi(getMonitorAoi);
    getLocationArea();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, isModalClicked]);

  useEffect(() => {
    if (!sketchVM) return;

    let monitorAoiPopover = false;
    const createEvent = sketchVM.on('create', event => {
      if (event.state === 'complete') {
        if (monitorAoiPopover) {
          popoverContentRef.current = 5;

          setIsMonitorAoiActive(true);
          setTimeout(() => {
            openMonitorAoiPopover();
          }, 300);
        }

        monitorAoiPopover = false;
      }

      if ((event.state as any) === 'monitorAoiComplete') {
        monitorAoiPopover = true;
      }
    });

    return () => {
      createEvent.remove();
    };
  }, [sketchVM]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.detail === 1) {
      //the default clicking menu

      MixpanelTracking.getInstance().track(MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_S);
      popoverContentRef.current = 1;
    }

    setIsModalClicked(true);
    // close the monitor aoi popper
    setIsMonitorAoiActive(false);
    setMonitorAoiAnchorEl(null);
    setAnchorEl(event.currentTarget);
    setIsActive(true);
  };

  const openMonitorAoiPopover = () => {
    setIsModalClicked(true);
    setIsMonitorAoiActive(true);
    setMonitorAoiAnchorEl(monitorAoiPopoverButtonRef.current);
  };

  const handleClickMonitorAoi = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    // do nothing because of the expanded option
    if (popoverContentRef.current === 5 || popoverContentRef.current === 6) return;
    popoverContentRef.current = 4;
    openMonitorAoiPopover();
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMonitorAoiAnchorEl(null);

    setIsActive(false);
    setIsMonitorAoiActive(false);
  };

  const handleMenuClick = async (
    event: React.MouseEvent<HTMLButtonElement>,
    name: string,
    id: string
  ) => {
    event.preventDefault();
    event.stopPropagation();

    //setting the old name
    saveAreaRef.current.id = id;
    saveAreaRef.current.name = name;

    const currentTarget = event.currentTarget;

    try {
      // eslint-disable-next-line require-use-server
      const coordinates = await getAreaLocationCoordinates_rh(id);
      if (coordinates?.error) {
        return customToaster(coordinates?.error);
      }
      selectedSavedAreaCoordinatesRef.current = coordinates;
    } catch (error: any) {
      customToaster('common:generalError');
    } finally {
      setAnchorElMenu({ element: currentTarget, state: 0 });
      setMenuLoader({ id, state: false });
    }
  };

  const handleMenuClose = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorElMenu({ element: null, state: 0 });
  };

  const handleBackToSaveArea = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorElMenu({ element: null, state: 0 });
  };

  async function onSubmit(data: { Name?: string }) {
    MixpanelTracking.getInstance().track(MixpanelEventHub.HUB_MY_SAVED_AREAS_NAME_AOI, {
      name: data?.Name,
    });
    triggerEvent(startLoaderEvent);
    if (await handleSaveArea(data?.Name)) {
      reset();
      handleClose();
    }

    triggerEvent(stopLoaderEvent);
  }

  const onError = (err: any) => {
    if (err?.Name?.type === 'required') {
      err?.Name?.ref.focus();
      return customToaster(t('formInvalidError'));
    }
  };

  const downloadAOIJsonFile = (name: any) => {
    //Format for AOI JSON File
    const aoiJSON = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: selectedSavedAreaCoordinatesRef?.current,
          },
        },
      ],
    };

    const json = JSON.stringify(aoiJSON, null, 2); // Pretty-print
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    //Filename using orderId
    link.download = `${saveAreaRef.current.name}_AOI.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Clean up
  };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  return (
    <>
      {/* Explore platform */}
      {isPlatformExplore && (
        <Button
          disabled={saveBtnDisable}
          size="small"
          name="save-area-button"
          onClick={event => {
            event.stopPropagation();
            popoverContentRef.current = 3;
            popoverButtonRef.current?.click();
            MixpanelTracking.getInstance().track(MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVE_AOI);
          }}
          className="btn-save-area"
          // className="stack-btn"
          variant="contained"
          sx={{
            backgroundColor: 'var(--secondary-color)',
            color: '#fff',
          }}
        >
          {t('saveArea')}
        </Button>
      )}

      {isPlatformExplore && (
        <Button
          name="saved-area-list-button"
          aria-label="saved-area-list-button"
          className={isActive ? 'saved-Area-btn btn-expand' : 'saved-Area-btn'}
          startIcon={<BookmarkBorderOutlinedIcon />}
          aria-describedby={id}
          onClick={handleClick}
          ref={popoverButtonRef}
        >
          <Typography variant="body2">{t('mySavedAreas')}</Typography>
          <KeyboardArrowDownOutlinedIcon />
        </Button>
      )}

      {/* Hub platform */}
      {isPlatformHub && !hideSaveMonitorAreaButtons && (
        <Stack direction="row" spacing={1} className="btn-save-area">
          <Button
            disabled={saveBtnDisable}
            size="small"
            name="save-area-button"
            onClick={event => {
              event.stopPropagation();
              popoverContentRef.current = 3;
              popoverButtonRef.current?.click();
              MixpanelTracking.getInstance().track(MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVE_AOI);
            }}
            // className="btn-save-area"
            className="stack-btn"
            variant="contained"
          >
            {t('saveArea')}
          </Button>

          <Button
            disabled={monitorAoiBtnDisable}
            size="small"
            name="monitor-aoi-button"
            onClick={event => {
              event.stopPropagation();

              // if the popper is in edit mode which is 6 then do nothing
              if (popoverContentRef.current === 6) return;
              popoverContentRef.current = 5;
              setIsMonitorAoiActive(true);
              setTimeout(() => {
                openMonitorAoiPopover();
              }, 300);
              MixpanelTracking.getInstance().track(MixpanelEventHub.HUB_MONITOR_AREA_CLICK);
            }}
            className="stack-btn"
            variant="contained"
          >
            {t('monitorArea', 'Monitor Area')}
          </Button>
        </Stack>
      )}

      {isPlatformHub && (
        <Stack direction="row" className="saved-Area-btn saved-area-btn-stack">
          <Button
            name="monitor-aoi-list-button"
            id="monitor-aoi-popover-button"
            aria-label="monitor-aoi-list-button"
            className={
              isMonitorAoiActive
                ? 'saved-Area-btn monitor-aoi-btn btn-expand'
                : 'saved-Area-btn monitor-aoi-btn move-left'
            }
            startIcon={<AccessTimeIcon />}
            aria-describedby={monitorAoiId}
            onClick={handleClickMonitorAoi}
          >
            <Typography variant="body2">{t('monitoredAreas', 'Monitored Areas')}</Typography>
            <KeyboardArrowDownOutlinedIcon ref={monitorAoiPopoverButtonRef} />
          </Button>

          <Button
            name="saved-area-list-button"
            aria-label="saved-area-list-button"
            className={isActive ? 'saved-Area-btn btn-expand' : 'saved-Area-btn'}
            startIcon={<BookmarkBorderOutlinedIcon />}
            aria-describedby={id}
            onClick={handleClick}
            ref={popoverButtonRef}
          >
            <Typography variant="body2">{t('mySavedAreas')}</Typography>
            <KeyboardArrowDownOutlinedIcon />
          </Button>
        </Stack>
      )}

      <SaveAreaPopover
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        setIsActive={setIsActive}
        open={open}
        id={id}
        user={userData}
        getPopOverContent={getPopOverContent}
      />

      {isPlatformHub && (
        <MonitorAoiPopover
          monitorAoiAnchorEl={monitorAoiAnchorEl}
          setMonitorAoiAnchorEl={setMonitorAoiAnchorEl}
          setIsMonitorAoiActive={setIsMonitorAoiActive}
          monitorAoiOpen={monitorAoiOpen}
          monitorAoiId={monitorAoiId}
          user={userData}
          getPopOverContent={getPopOverContent}
          popoverContentRef={popoverContentRef}
          monitorAoiHelperRef={monitorAoiHelperRef}
        />
      )}
    </>
  );
}
